import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowDown } from 'react-icons/fa';
import './Hero.css';
import heroImage from './IMG_9380.JPEG';

const Hero = () => {
  return (
    <section id="home" className="hero" style={{ '--hero-image': `url(${heroImage})` }}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h1 className="hero-title">
            Capturing <span className="highlight">Moments</span>
            <br />
            Creating <span className="highlight">Memories</span>
          </h1>
        </motion.div>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          Professional Photography & Videography Services
          <br />
          Transforming your vision into stunning visual stories
        </motion.p>

        <motion.div
          className="hero-buttons"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
        >
          <a href="#gallery" className="btn btn-primary">View Portfolio</a>
          <a href="#contact" className="btn btn-secondary">Get in Touch</a>
        </motion.div>

        <motion.div
          className="scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
        >
          <a href="#about">
            <FaArrowDown className="scroll-icon" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
